import type { SVGProps } from 'react';
import { clsx } from 'clsx';
import styles from './decorative-bank-icon.module.scss';

interface DecorativeBankIconProps extends SVGProps<SVGSVGElement> {
  fill: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
}

export function DecorativeBankIcon({ className, fill, ...props }: DecorativeBankIconProps) {
  return (
    <svg className={clsx(styles.decorativeBankIcon, className)} fill="none" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Bank icon</title>

      <path
        className={styles[`fill-${fill}`]}
        clipRule="evenodd"
        d="M8.71323 2.73348C8.2844 2.43552 7.71554 2.43552 7.28672 2.73348L1.54257 6.72464C0.537088 7.42327 1.03146 9.00117 2.25583 9.00117H2.5V12.5012C1.67157 12.5012 1 13.1727 1 14.0012V15.0012C1 15.8296 1.67157 16.5012 2.5 16.5012H13.5C14.3284 16.5012 15 15.8296 15 15.0012V14.0012C15 13.1727 14.3284 12.5012 13.5 12.5012V9.00117H13.7441C14.9685 9.00117 15.4629 7.42327 14.4574 6.72464L8.71323 2.73348Z"
        fillRule="evenodd"
        opacity="0.2"
      />

      <path
        clipRule="evenodd"
        d="M8.71323 1.23226C8.2844 0.934299 7.71554 0.9343 7.28672 1.23226L1.54257 5.22342C0.537088 5.92205 1.03146 7.49995 2.25583 7.49995H2.5V10.9999C1.67157 10.9999 1 11.6715 1 12.4999V13.4999C1 14.3284 1.67157 14.9999 2.5 14.9999H13.5C14.3284 14.9999 15 14.3284 15 13.4999V12.4999C15 11.6715 14.3284 10.9999 13.5 10.9999V7.49995H13.7441C14.9685 7.49995 15.4629 5.92205 14.4574 5.22342L8.71323 1.23226ZM3.05377 5.99995L7.99997 2.56321L12.9462 5.99995H3.05377ZM12 7.49995H10.3333V10.9999H12V7.49995ZM8.83331 7.49995H7.16669L7.16669 10.9999H8.83331L8.83331 7.49995ZM5.66669 7.49995H4L4 10.9999H5.66669L5.66669 7.49995ZM13.5 12.4999H2.5V13.4999H13.5V12.4999Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
